// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDRaiYiUVZ7sy0F3AeO9ooAq6fcDxwjpaA",
  authDomain: "anne-andersen-foto.firebaseapp.com",
  projectId: "anne-andersen-foto",
  storageBucket: "anne-andersen-foto.appspot.com",
  messagingSenderId: "291909295395",
  appId: "1:291909295395:web:b259435abe977d09050096",
  measurementId: "G-0QVQFHMZEW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, auth, analytics };
